import Tooltip from "react-bootstrap/Tooltip";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import React, { ReactElement } from "react";

type PlacementType = "top" | "right" | "bottom" | "left" | "auto";

interface ToolTipProps {
    text: string | ReactElement;
    placement: PlacementType;
    children: ReactElement;
    align?: "end" | "center" | "bottom";
    overlayTooltipKey?: number;
    key?: number | string;
}

const TooltipCustom: React.FC<ToolTipProps> = ({
    text,
    placement,
    children,
    align = "start",
    overlayTooltipKey,
    key,
}) => {
    if (!text) return children;

    const renderTooltip = (text: string | ReactElement) => (
        <Tooltip id="tooltip" className="pointer-events-none">
            <span className={`d-block w-100 text-${align}`}>{text}</span>
        </Tooltip>
    );
    return (
        <OverlayTrigger
            key={overlayTooltipKey || key}
            placement={placement}
            overlay={renderTooltip(text)}
            container={document.body}
            flip
        >
            {children}
        </OverlayTrigger>
    );
};

export default TooltipCustom;
